<template>
  <div id="resumo-proposta">
    <v-row>
      <v-col cols="12" class="py-0 grey--text text--darken-4 font-weight-regular">
        <div class="pl-4" style="font-size: 16px">
          <v-row no-gutters>
            <v-col cols="12" class="pb-0">
              <span class="text-strong">Dados do Cliente:</span>
            </v-col>
            <v-col cols="4">
              <span class="text-label-1">Documento Federal</span>
              {{ model.Cliente.DocumentoFederal }}
            </v-col>
            <v-col cols="4">
              <span class="text-label-1">Nome / Razão Social</span>
              {{ model.Cliente.Nome }}
            </v-col>
            <v-col cols="4" v-if="model.Cliente?.PessoaDadosContato">
              <span class="text-label-1">Celular</span>
              {{ model.Cliente.PessoaDadosContato.TelefoneCelular1 }}
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-2" v-if="model.Cliente?.PessoaDadosContato">
            <v-col cols="8">
              <span class="text-label-1">E-MAIL</span>
              {{ model.Cliente.PessoaDadosContato.Email }}
            </v-col>
          </v-row>
          <template v-if="model.Cliente?.PessoaEndereco">
            <v-row no-gutters class="mt-5">
              <v-col cols="12" class="pb-0">
                <span class="text-strong">Endereço:</span>
              </v-col>
              <v-col cols="4">
                <span class="text-label">CEP:</span>
                {{ model.Cliente.PessoaEndereco.CEP }}
              </v-col>
              <v-col cols="4">
                <span class="text-label">Bairro:</span>
                {{ model.Cliente.PessoaEndereco.Bairro }}
              </v-col>
              <v-col cols="4">
                <span class="text-label">Cidade:</span>
                {{ model.Cliente.PessoaEndereco.Cidade }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="4">
                <span class="text-label">Logradouro:</span>
                {{ model.Cliente.PessoaEndereco.Logradouro }}
              </v-col>
              <v-col cols="4">
                <span class="text-label">Nº:</span>
                {{ model.Cliente.PessoaEndereco.NroLogradouro }}
              </v-col>
              <v-col cols="4">
                <span class="text-label">UF:</span>
                {{ model.Cliente.PessoaEndereco.UF }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="8">
                <span class="text-label">Complemento:</span>
                {{ model.Cliente.PessoaEndereco.Complemento }}
              </v-col>
            </v-row>
          </template>
          <v-row no-gutters class="mt-5">
            <v-col cols="12" class="pb-0">
              <span class="text-strong">Operação de Crédito:</span>
            </v-col>
            <v-col cols="6">
              <span class="text-label">Tipo de Operação:</span>
              {{ model.TipoOperacaoNome }}
            </v-col>
            <v-col cols="6">
              <span class="text-label">Produto:</span>
              {{ model.TipoContratoDescricao }}
            </v-col>
            <v-col cols="6">
              <span class="text-label">Tipo de Cálculo:</span>
              {{this.$aux.TipoFluxo.find((item) => (item.value === model.TipoCalculoFluxo))?.text || '--'}}
            </v-col>
          </v-row>

          <v-row class="mt-5" no-gutters>
            <v-col cols="12">
              <span class="text-strong">Dados da Operação de Crédito:</span>
            </v-col>
            <v-col cols="12">
              <div class="item-value" v-if="model.VlrRegistroImovel">
                <span class="text-value-label">Valor de Registro do Imóvel:</span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrRegistroImovel) }}</span>
              </div>
              <div class="item-value" v-if="model.VlrRegistroGarantia">
                <span class="text-value-label">Registro de Termo de Garantia:</span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrRegistroGarantia) }}</span>
              </div>
              <div class="item-value" v-if="model.VlrITBI">
                <span class="text-value-label">Valor de ITBI:</span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrITBI) }}</span>
              </div>
              <div class="item-value">
                <span class="text-value-label">Valor Líquido Solicitado:</span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrSolicitado) }}</span>
                <v-tooltip top v-if="model.ModeloCalculo === $api.Estruturadas.ModeloCalculoEnum.SAC">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mr-lg-2" color="primary" v-on="on" small icon><v-icon medium>ph-info</v-icon></v-btn>
                  </template>
                  <span>Imóvel - Entrada + Registro + ITBI + Registro de Garantia.</span>
                </v-tooltip>
              </div>

              <div class="item-value">
                <span class="text-value-label">Tarifa de Cadastro:</span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrTAC) }}</span>
              </div>

              <template v-if="model.OutrosServicos">
                <div class="item-value" v-if="model.VlrSeguro > 0">
                  <span class="text-value-label">Seguro:</span>
                  <span class="text-value">{{ $api.UI.Format.Currency(model.VlrSeguro || 0) }}</span>
                </div>

                <div class="item-value" v-if="model.VlrAvaliacao > 0">
                  <span class="text-value-label">Tarifa de Avaliação:</span>
                  <span class="text-value">{{ $api.UI.Format.Currency(model.VlrAvaliacao || 0) }}</span>
                </div>

                <div class="item-value" v-if="model.VlrVistoria > 0">
                  <span class="text-value-label">Tarifa de Vistoria:</span>
                  <span class="text-value">{{ $api.UI.Format.Currency(model.VlrVistoria || 0) }}</span>
                </div>
              </template>

              <div class="item-value" v-if="model.VlrRegistro > 0">
                <span class="text-value-label">Valor do Registro:</span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrRegistro) }}</span>
              </div>

              <div class="item-value" v-if="vlrRegistro > 0">
                <span class="text-value-label">Valor do Registro:</span>
                <span class="text-value">{{ $api.UI.Format.Currency(vlrRegistro) }}</span>
              </div>

              <div class="item-value" v-if="model.TipoCalculoFluxo !== $aux.TipoFluxoEnum.Irregular">
                <span class="text-value-label">Valor Total Solicitado:</span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrTotalSolicitado) }}</span>
                <v-tooltip top v-if="model.ModeloCalculo === $api.Estruturadas.ModeloCalculoEnum.SAC">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mr-lg-2" color="primary" v-on="on" small icon><v-icon medium>ph-info</v-icon></v-btn>
                  </template>
                  <span>Imóvel - Entrada + Registro + ITBI + TAC + Tarifa Vistoria + Tarifa Avaliação + Seguro + Registro de Garantia.</span>
                </v-tooltip>
              </div>

              <div class="item-value">
                <span class="text-value-label">IOF:</span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrIOF) }}</span>
              </div>

              <div class="item-value" v-if="model.VlrTxAdmMensal">
                <span class="text-value-label">Taxa de Administração Mensal:</span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrTxAdmMensal) }}</span>
              </div>
            </v-col>

            <v-col cols="6" class="item-value my-2 font-weight-bold">
              <span class="text-value-label">Valor Total Financiado:</span>
              <span class="text-value">{{ $api.UI.Format.Currency(model.VlrTotalFinanciado) }}</span>
            </v-col>
            <v-col cols="6" class="item-value my-2 font-weight-bold">
              <span class="text-value-label">Prestações:</span>
              <span class="text-value">{{ $api.UI.Format.Date(model.PrimeiraParcela.DtVencimento) }} até {{
                $api.UI.Format.Date(model.UltimaParcela.DtVencimento) }}</span>
            </v-col>

            <v-col cols="6" class="item-value font-weight-bold">
              <span class="text-value-label">Número de Prestações:</span>
              <span class="text-value">{{ model.Parcelas.length }}</span>
            </v-col>
            <v-col v-if="this.model.TipoCalculoFluxo !== this.$aux.TipoFluxoEnum.Irregular" cols="6" class="item-value">
              <span class="text-value-label">Valor da Prestação:</span>
              <span class="text-value">{{ $api.UI.Format.Currency(model.PrimeiraParcela.VlrPrestacaoTotal) }}</span>
            </v-col>
            <v-col cols="6" class="item-value">
              <span class="text-value-label">Taxa de Juros:</span>
              <span class="text-value" v-if="model.TipoContratoDescricao && model.TipoContratoDescricao.includes('FI')">{{ $api.UI.Format.Decimal(model.PercJurosAnual) }}% a.a.</span>
              <span class="text-value" v-else>{{ $api.UI.Format.Decimal(model.PercJurosMensal) }}% a.m.</span>
            </v-col>
            <v-col cols="6" class="item-value">
              <span class="text-value-label">CET:</span>
              <span class="text-value">{{ $api.UI.Format.Decimal(model.PercCETMensal) }}% a.m. / {{
                $api.UI.Format.Decimal(model.PercCETAnual) }}% a.a.</span>
            </v-col>
            <v-col cols="6" class="item-value">
              <span class="text-value-label">Amortização:</span>
              <span class="text-value">{{ model.ModeloCalculo === $api.Estruturadas.ModeloCalculoEnum.Price ? 'Price' :
                'SAC'}}</span>
            </v-col>
            <v-col cols="6" class="item-value">
              <span class="text-value-label">Modalidade:</span>
              <span class="text-value">{{ model.TipoIndexador === 1 ? 'Pré-Fixado' : 'Pós-Fixado' }} </span>
            </v-col>
            <v-col cols="6" class="item-value" v-if="model.TipoIndexador === 2">
              <span class="text-value-label">Indexador:</span>
              <span class="text-value">{{ indexador }} </span>
            </v-col>

            <v-col cols="12" class="mt-5">
              <span class="text-strong">Prestações:</span>
            </v-col>
            <v-col cols="6" class="item-value">
              <span class="text-label-1">1º Prestação</span>
              <span class="text-value">
                Data: {{ $api.UI.Format.Date(model.PrimeiraParcela.DtVencimento) }}<br />
                Valor: {{ $api.UI.Format.Currency(model.PrimeiraParcela.VlrPrestacaoTotal) }}
                {{ model.TipoIndexador === 2 ? `+ ${model.PercIndiceFinan}% do índice ${indexador}` : '' }}
              </span>
            </v-col>

            <v-col cols="6" class="item-value">
              <span class="text-label-1">Última Prestação</span>
              <span class="text-value">
                Data: {{ $api.UI.Format.Date(model.UltimaParcela.DtVencimento) }} <br />
                Valor: {{ $api.UI.Format.Currency(model.UltimaParcela.VlrPrestacaoTotal) }}
                {{ model.TipoIndexador === 2 ? `+ ${model.PercIndiceFinan}% do índice ${indexador}` : '' }}
              </span>
            </v-col>

            <v-col cols="6" class="item-value mt-5">
              <span class="text-label-1 font-weight-bold">Valor Total da Dívida</span>
              <span class="text-value">{{ $api.UI.Format.Currency(model.VlrTotalDivida) }}</span>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col cols="12" class="pl-4 pb-0 mt-6 d-flex justify-center">
            <span style="font-size: 16px" class="text-strong">Fluxo de Pagamento</span>
          </v-col>
          <v-col cols="12" class="px-2 pt-0">

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th> Parcela </th>
                    <th> Vencimento </th>
                    <th> Principal </th>
                    <th> Prestação </th>
                    <th v-if="model.ModeloCalculo === $api.Estruturadas.ModeloCalculoEnum.SAC"> Taxa Adm. </th>
                    <th v-if="model.ModeloCalculo === $api.Estruturadas.ModeloCalculoEnum.SAC"> Seguro MIP </th>
                    <th v-if="model.ModeloCalculo === $api.Estruturadas.ModeloCalculoEnum.SAC"> Seguro DFI </th>
                    <th> Juros </th>
                    <th> Saldo Devedor </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="model.Parcelas.length === 0">
                    <td colspan="4" class="text-center text--disabled">Aguardando geração das parcelas</td>
                  </tr>
                  <tr v-for="(item, index) in model.Parcelas" :key="index">
                    <template v-if="index < 3 || verTodasParcelas">
                      <td>{{ (item.NumeroParcela || index) + 1 }}</td>
                      <td>{{ $api.UI.Format.Date(item.DtVencimento) }}</td>
                      <td>{{ item.VlrAmortizacao !== null ? $api.UI.Format.Currency(item.VlrAmortizacao) : '-' }}</td>
                      <td>{{ $api.UI.Format.Currency(item.VlrPrestacaoTotal) }}</td>
                      <td v-if="model.ModeloCalculo === $api.Estruturadas.ModeloCalculoEnum.SAC">
                        <span
                          style="display:inline-block; min-width:70px; text-align:left;">
                          {{ $api.UI.Format.Currency(item.VlrTxAdmMensal) }}
                        </span>
                        </td>
                      <td v-if="model.ModeloCalculo === $api.Estruturadas.ModeloCalculoEnum.SAC">
                        <span
                          style="display:inline-block; min-width:70px; text-align:left;">
                          {{ $api.UI.Format.Currency(item.VlrSeguroMensal1) }}
                        </span></td>
                      <td v-if="model.ModeloCalculo === $api.Estruturadas.ModeloCalculoEnum.SAC"><span
                          style="display:inline-block; min-width:70px; text-align:left;">
                          {{ $api.UI.Format.Currency(item.VlrSeguroMensal2) }}
                        </span></td>
                      <td>{{ item.VlrJurosMensal !== null ? $api.UI.Format.Currency(item.VlrJurosMensal) : '-' }}</td>
                      <td>{{ item.VlrSaldoDevedor !== null ? $api.UI.Format.Currency(item.VlrSaldoDevedor) : '-' }}</td>
                    </template>
                    <td role="button" v-else-if="index === 3" colspan="12"
                      class="text-center text-decoration-underline primary--text" @click="verTodasParcelas = true">
                      ver todas as parcelas
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <template v-if="resumoProposta && isLoaded">
          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Documentos do Emitente</span>
            </v-col>
            <v-col cols="12">
              <DocumentoGrid :tipo="$aux.TipoDocumentoEntidade.Pessoa" resumo :codigoProposta="model.Codigo"
                :codigoPessoa="model.CodigoCliente" :key="model.Codigo" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Documentos da Proposta</span>
            </v-col>
            <v-col cols="12">
              <DocumentoGrid :tipo="$aux.TipoDocumentoEntidade.Proposta" resumo :codigoProposta="model.Codigo"
                :key="model.Codigo" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Garantidores</span>
            </v-col>
            <v-col cols="12">
              <PropostaAvalista resumo :value="model"></PropostaAvalista>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Garantias</span>
            </v-col>
            <v-col cols="12">
              <PropostaGarantia resumo :value="model"></PropostaGarantia>
            </v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue'
export default {
  components: {
    PropostaAvalista: defineAsyncComponent(() => import(`@/views/${window.$bancodofuturo}/proposta/PropostaAvalista.vue`)),
    PropostaGarantia: defineAsyncComponent(() => import(`@/views/${window.$bancodofuturo}/proposta/PropostaGarantia.vue`)),
  },
  props: {
    resumoProposta: { type: Boolean, default: false },
    modal: { type: Boolean, default: false },
    vlrRegistro: null,
  },
  data () {
    return {
      model: {
        Cliente: {},
        Parcelas: {},
        PrimeiraParcela: {},
        UltimaParcela: {}
      },
      isLoaded: false,
      verTodasParcelas: false
    };
  },
  computed: {
    indexador () {
      const th = this
      return th.$api.Estruturadas.Indexador.find(p => p.value === th.model.TipoIndiceFinan)?.text
    }
  },
  methods: {
    async load (model) {
      this.isLoaded = false
      this.$api.UTIL.Functions.SetAllButNull(this, this, 'model', model)
      if (this.model.Codigo) await this.$api.Estruturadas.ListPropostaCampoAuxiliar(this, this.model.Codigo)
      this.$nextTick(() => {
        this.isLoaded = true
      })
    },
  }
}

</script>

<style>
#resumo-proposta span.text-label-1 {
  display: block;
}

#resumo-proposta span.text-label {
  margin-right: 2px
}

#resumo-proposta span.text-strong {
  font-weight: 600;
}

#resumo-proposta span.text-value-label,
#resumo-proposta span.text-subtitle-1 {
  margin-right: 2px
}

#resumo-proposta span.text-value {
  text-align: end;
}
</style>
